module.exports = __webpack_public_path__ + "d8b726eddf522adfe06a9d29ff371d21.fbx";